import { LayoutConst } from "core";
import styled from "styled-components";

export const FlowWrapper = styled.div`
    width: 100%;
    max-width: min(98vw, 1152px);
    background-color: ${p => p.theme.payment.chooseMethod.bg};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    border-radius: 8px;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 744px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 0;
        background-color: transparent;
        width: 100%;
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        max-width: 100vw;
        // max-height: fit-content;
        // gap:32px;
        height: 100%;
    }

`

export const PaymentFlowButtons = styled.div`
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    display: grid;
    grid-template-columns: 1fr 1fr;

    > div:nth-child(2) {
        justify-content: flex-end !important;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 0;
        grid-template-columns: 1fr;
    }
`

export const EmptyLeftSide = styled.div`

@media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
}
@media (max-width: ${LayoutConst.screen.s}px) {
    width: 0;
}
`

export const FlowChildren = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 24px;
`import { LayoutConst } from "core";
import styled from "styled-components";

export const FlowWrapper = styled.div`
    width: 100%;
    max-width: min(98vw, 1152px);
    background-color: ${p => p.theme.payment.chooseMethod.bg};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    border-radius: 8px;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 744px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 0;
        background-color: transparent;
        width: 100%;
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        max-width: 100vw;
        // max-height: fit-content;
        // gap:32px;
        height: 100%;
    }

`

export const PaymentFlowButtons = styled.div`
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    display: grid;
    grid-template-columns: 1fr 1fr;

    > div:nth-child(2) {
        justify-content: flex-end !important;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 0;
        grid-template-columns: 1fr;
    }
`

export const EmptyLeftSide = styled.div`

@media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
}
@media (max-width: ${LayoutConst.screen.s}px) {
    width: 0;
}
`

export const FlowChildren = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 24px;
`